/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.144",
  "buildId": "20260803-1752-5935209",
  "builtAt": "2026-08-03T12:22:16.876Z"
});
